import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6" }
const _hoisted_2 = { class: "md:col-span-3 relative" }
const _hoisted_3 = {
  key: 0,
  class: "absolute right-0 top-0 mt-4 mr-2"
}
const _hoisted_4 = {
  key: 1,
  role: "status",
  class: "mt-1 flex items-start gap-1 text-xs text-left text-amber-700",
  "data-testid": "unit-cep-lookup-warning"
}
const _hoisted_5 = { class: "md:col-span-3" }
const _hoisted_6 = { class: "md:col-span-6" }
const _hoisted_7 = { class: "md:col-span-8" }
const _hoisted_8 = { class: "md:col-span-4" }
const _hoisted_9 = { class: "md:col-span-6" }
const _hoisted_10 = { class: "md:col-span-6" }
const _hoisted_11 = { class: "md:col-span-6" }
const _hoisted_12 = { class: "md:col-span-6" }
const _hoisted_13 = { class: "md:col-span-12 mt-1" }

import { ref } from 'vue'
import { mdiAlertOutline } from '@mdi/js'
import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import StatesFromBR from '@/config/StatesFromBR'
import { injectHealthUnitForm } from '../../composables/useHealthUnitForm'
import { maskPostalCodeInput } from '../../helpers/postalCode'
import { syncMaskedInput } from '../../helpers/maskedInput'
import type { MaskedField } from '../../helpers/maskedInput'
import UnitFormSection from './UnitFormSection.vue'
import UnitLocationStatus from './UnitLocationStatus.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitAddressFields',
  props: {
    disabled: { type: Boolean },
    isLoadingCep: { type: Boolean },
    cepWarning: { default: null },
    latitude: {},
    longitude: {},
    locationConfirmed: { type: Boolean },
    isVerifyingLocation: { type: Boolean }
  },
  emits: ["address-changed", "verify-location"],
  setup(__props: any, { emit }) {





const { form, validate, rules } = injectHealthUnitForm()

const postalCodeField = ref<MaskedField>(null)

function onPostalCodeInput(value: string | number | undefined): void {
  const masked = maskPostalCodeInput(value)
  form.values.postalCode = masked
  syncMaskedInput(postalCodeField, masked)
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UnitFormSection, { title: "Endereço" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled || _ctx.isLoadingCep,
            required: "",
            label: "CEP",
            rules: [_unref(rules).form('postalCode')],
            width: "100%",
            ref_key: "postalCodeField",
            ref: postalCodeField,
            "model-value": _unref(form).values.postalCode,
            "onUpdate:modelValue": onPostalCodeInput,
            onValidate: _cache[0] || (_cache[0] = ($event: any) => (_unref(validate)('postalCode'))),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (emit('address-changed'))),
            loading: _ctx.isLoadingCep,
            "validate-on": "submit",
            "data-testid": "unit-cep-input"
          }, null, 8, ["disabled", "rules", "model-value", "loading"]),
          (_ctx.isLoadingCep)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "primary",
                  size: "20"
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.cepWarning)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _createVNode(_component_v_icon, {
                  icon: _unref(mdiAlertOutline),
                  size: "14",
                  class: "mt-px shrink-0"
                }, null, 8, ["icon"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.cepWarning), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_autocomplete, {
            disabled: _ctx.disabled,
            modelValue: _unref(form).values.state,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).values.state) = $event)),
            class: "w-full",
            rules: [_unref(rules).required],
            required: "",
            color: "primary20",
            label: "* Estado",
            theme: "light",
            items: _unref(StatesFromBR),
            variant: "outlined",
            "data-testid": "unit-state-select"
          }, null, 8, ["disabled", "modelValue", "rules", "items"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            required: "",
            label: "Cidade",
            rules: [_unref(rules).form('city')],
            width: "100%",
            modelValue: _unref(form).values.city,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).values.city) = $event)),
            onValidate: _cache[4] || (_cache[4] = ($event: any) => (_unref(validate)('city'))),
            onInput: _cache[5] || (_cache[5] = ($event: any) => (emit('address-changed'))),
            "data-testid": "unit-city-input"
          }, null, 8, ["disabled", "rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            required: "",
            label: "Rua",
            rules: [_unref(rules).form('street')],
            width: "100%",
            modelValue: _unref(form).values.street,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).values.street) = $event)),
            onValidate: _cache[7] || (_cache[7] = ($event: any) => (_unref(validate)('street'))),
            onInput: _cache[8] || (_cache[8] = ($event: any) => (emit('address-changed'))),
            "data-testid": "unit-street-input"
          }, null, 8, ["disabled", "rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            required: "",
            label: "Número",
            rules: [_unref(rules).form('number')],
            width: "100%",
            modelValue: _unref(form).values.number,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).values.number) = $event)),
            onValidate: _cache[10] || (_cache[10] = ($event: any) => (_unref(validate)('number'))),
            onInput: _cache[11] || (_cache[11] = ($event: any) => (emit('address-changed'))),
            "data-testid": "unit-number-input"
          }, null, 8, ["disabled", "rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            required: "",
            label: "Bairro",
            rules: [_unref(rules).form('neighborhood')],
            width: "100%",
            modelValue: _unref(form).values.neighborhood,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).values.neighborhood) = $event)),
            onValidate: _cache[13] || (_cache[13] = ($event: any) => (_unref(validate)('neighborhood'))),
            onInput: _cache[14] || (_cache[14] = ($event: any) => (emit('address-changed'))),
            "data-testid": "unit-neighborhood-input"
          }, null, 8, ["disabled", "rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            label: "Complemento",
            rules: [_unref(rules).form('complement')],
            width: "100%",
            modelValue: _unref(form).values.complement,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(form).values.complement) = $event)),
            onValidate: _cache[16] || (_cache[16] = ($event: any) => (_unref(validate)('complement'))),
            "data-testid": "unit-complement-input"
          }, null, 8, ["disabled", "rules", "modelValue"])
        ])
      ]),
      _: 1
    }),
    _createVNode(UnitFormSection, {
      title: "Coordenadas",
      hint: "preenchidas ao verificar a localização"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(GenericInput, {
            rules: [_unref(rules).form('latitude')],
            onValidate: _cache[17] || (_cache[17] = ($event: any) => (_unref(validate)('latitude'))),
            label: "Latitude",
            width: "100%",
            disabled: "",
            "model-value": _ctx.latitude
          }, null, 8, ["rules", "model-value"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(GenericInput, {
            rules: [_unref(rules).form('longitude')],
            onValidate: _cache[18] || (_cache[18] = ($event: any) => (_unref(validate)('longitude'))),
            label: "Longitude",
            width: "100%",
            disabled: "",
            "model-value": _ctx.longitude
          }, null, 8, ["rules", "model-value"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(UnitLocationStatus, {
            confirmed: _ctx.locationConfirmed,
            verifying: _ctx.isVerifyingLocation,
            readonly: _ctx.disabled,
            onVerify: _cache[19] || (_cache[19] = ($event: any) => (emit('verify-location')))
          }, null, 8, ["confirmed", "verifying", "readonly"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})